<template lang="pug">
div
	.position-relative
		// Hero for FREE version
		section.section.section-lg.section-hero.heroPlastomex
			div(style='height: fit-content')
				h1.h-titulo Cajas y Tapas
				p.lead.h-subtitulo
	
	section.section.section-lg.pt-lg-0.mt--100
		.container
			.row.justify-content-center
				.col-6.col-lg-4.my-3(v-for="i in cajas")
					.card.card-lift--hover.shadow.border-0.text-center(@click="show_mocalC(i)")
						picture
							source(:srcset='webp(i.img)' type="image/webp" )
							img.card-img-top(:src='i.img', alt='Card image cap')
						.card-body.px-0.py-lg-5
							h6.text-primary.display-4.text-uppercase {{i.titulo}}
							//-button.btn.btn-primary.btn-sm.mt-4.ml-0(@click="show_mocalC(i)") Especificaciones
			
				.col-6.col-lg-4.my-3(v-for="i in tapas")
					.card.card-lift--hover.shadow.border-0.text-center(@click="show_modalT(i)")
						picture
							source(:srcset='webp(i.img)' type="image/webp" )
							img.card-img-top(:src='i.img', alt='Imagen tapa')
						.card-body.px-0.py-5
							h6.text-primary.text-uppercase {{i.titulo}}
							//-button.btn.btn-primary.btn-sm.mt-4(@click="show_modalT(i)") especificaciones

	b-modal(v-model='modalC' size="lg" )
		h6#modal-title-default.modal-title(slot='header') 
		.modal-body.especificaciones(v-if="modalC")
			h4.titulo-producto {{seleccionada_c.titulo}}
			picture
				source(:srcset='webp(seleccionada_c.img)' type="image/webp" )
				img(:src='seleccionada_c.img', alt='Imagen del producto')
			.row
				.col-12.col-lg-6.text-left
					h4 Medidas Internas
					ul
						li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M9,11H15V8L19,12L15,16V13H9V16L5,12L9,8V11M2,20V4H4V20H2M20,20V4H22V20H20Z')
							|                             Ancho: 
							span#anchoE.cm {{seleccionada_c.interior.ancho}}
						li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M13,9V15H16L12,19L8,15H11V9H8L12,5L16,9H13M4,2H20V4H4V2M4,20H20V22H4V20Z')
							|                             Alto Frontal: 
							span#altofE.cm {{seleccionada_c.interior.alto_frontal}}
						li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z')
							|                             Alto Lateral: 
							span#altolE.cm {{seleccionada_c.interior.alto_lateral}}
						li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z')
							|                             Largo: 
							span#largoE.cm {{seleccionada_c.interior.largo}}
				.col-12.col-lg-6.text-left
					h4 Medidas Externas
					ul
						li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M9,11H15V8L19,12L15,16V13H9V16L5,12L9,8V11M2,20V4H4V20H2M20,20V4H22V20H20Z')
							|                             Ancho: 
							span#anchoE.cm {{seleccionada_c.exterior.ancho}}
						li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M13,9V15H16L12,19L8,15H11V9H8L12,5L16,9H13M4,2H20V4H4V2M4,20H20V22H4V20Z')
							|                             Alto Frontal: 
							span#altofE.cm {{seleccionada_c.exterior.alto_frontal}}
						li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z')
							|                             Alto Lateral: 
							span#altolE.cm {{seleccionada_c.exterior.alto_lateral}}
						li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z')
							|                             Largo: 
							span#largoE.cm {{seleccionada_c.exterior.largo}}
				.col-12.text-left
					ul
						//-li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M19.95,10.56C19.75,9.67 18.95,9 18,9H15.46C15.81,8.41 16,7.73 16,7A4,4 0 0,0 12,3A4,4 0 0,0 8,7C8,7.73 8.19,8.41 8.54,9H6C5.05,9 4.25,9.67 4.05,10.56C2.04,18.57 2,18.78 2,19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19C22,18.78 21.96,18.57 19.95,10.56M12,5A2,2 0 0,1 14,7A2,2 0 0,1 12,9A2,2 0 0,1 10,7A2,2 0 0,1 12,5M15,13H11V17H13V14H15V19H11C9.89,19 9,18.11 9,17V13C9,11.89 9.89,11 11,11H15V13Z')
							|                         Peso: 
							span#peso.gr {{}}
						li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L6.04,7.5L12,10.85L17.96,7.5L12,4.15Z')
							|                         Volumen: 
							span#vol.m3  {{seleccionada_c.volumen}}
						li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M2,10.96C1.5,10.68 1.35,10.07 1.63,9.59L3.13,7C3.24,6.8 3.41,6.66 3.6,6.58L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.66,6.72 20.82,6.88 20.91,7.08L22.36,9.6C22.64,10.08 22.47,10.69 22,10.96L21,11.54V16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V10.96C2.7,11.13 2.32,11.14 2,10.96M12,4.15V4.15L12,10.85V10.85L17.96,7.5L12,4.15M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V12.69L14,15.59C13.67,15.77 13.3,15.76 13,15.6V19.29L19,15.91M13.85,13.36L20.13,9.73L19.55,8.72L13.27,12.35L13.85,13.36Z')
							|                         Pallet: 
							span#pallet {{seleccionada_c.pallet}}
						li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M2,10.96C1.5,10.68 1.35,10.07 1.63,9.59L3.13,7C3.24,6.8 3.41,6.66 3.6,6.58L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.66,6.72 20.82,6.88 20.91,7.08L22.36,9.6C22.64,10.08 22.47,10.69 22,10.96L21,11.54V16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V10.96C2.7,11.13 2.32,11.14 2,10.96M12,4.15V4.15L12,10.85V10.85L17.96,7.5L12,4.15M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V12.69L14,15.59C13.67,15.77 13.3,15.76 13,15.6V19.29L19,15.91M13.85,13.36L20.13,9.73L19.55,8.72L13.27,12.35L13.85,13.36Z')
							|                         Tolerancia térmica: 
							span#tolerancia {{seleccionada_c.tolerancia_t}}
						hr
						li
							| Aplicaciones: 
							ul#aplicaciones
								li(v-for="a in seleccionada_c.aplicaciones")
									span {{a}}

		template(slot='modal-footer')
			router-link.btn.btn-primary(to="/contacto#contacto") Cotizar
			base-button.ml-auto(type='secondary', @click="modalC = false") X

	modal(:show.sync='modalT', modalClasses="modal-lg")
		h6.modal-title(slot='header') {{ seleccionada_t.titulo }}
		picture
			source(:srcset='webp(seleccionada_t.img)' type="image/webp" )
			img( :src="seleccionada_t.img" alt="Imagen del producto")
		.row.justify-content-center.mt-4
			.col-md-9.text-left
				ul
					li
						svg(style='width:24px;height:24px', viewBox='0 0 24 24')
							path(fill='#000000', d='M9,11H15V8L19,12L15,16V13H9V16L5,12L9,8V11M2,20V4H4V20H2M20,20V4H22V20H20Z')
						| Ancho: 
						span.cm {{seleccionada_t.ancho}}
					li
						svg(style='width:24px;height:24px', viewBox='0 0 24 24')
							path(fill='#000000', d='M13,9V15H16L12,19L8,15H11V9H8L12,5L16,9H13M4,2H20V4H4V2M4,20H20V22H4V20Z')
						| Largo: 
						span.cm {{seleccionada_t.largo}}
					//-li
						svg(style='width:24px;height:24px', viewBox='0 0 24 24')
							path(fill='#000000', d='M19.95,10.56C19.75,9.67 18.95,9 18,9H15.46C15.81,8.41 16,7.73 16,7A4,4 0 0,0 12,3A4,4 0 0,0 8,7C8,7.73 8.19,8.41 8.54,9H6C5.05,9 4.25,9.67 4.05,10.56C2.04,18.57 2,18.78 2,19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19C22,18.78 21.96,18.57 19.95,10.56M12,5A2,2 0 0,1 14,7A2,2 0 0,1 12,9A2,2 0 0,1 10,7A2,2 0 0,1 12,5M15,13H11V17H13V14H15V19H11C9.89,19 9,18.11 9,17V13C9,11.89 9.89,11 11,11H15V13Z')
						| Peso: 
						span.gr {{}}
					li
						svg(style='width:24px;height:24px', viewBox='0 0 24 24')
							path(fill='#000000', d='M2,10.96C1.5,10.68 1.35,10.07 1.63,9.59L3.13,7C3.24,6.8 3.41,6.66 3.6,6.58L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.66,6.72 20.82,6.88 20.91,7.08L22.36,9.6C22.64,10.08 22.47,10.69 22,10.96L21,11.54V16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V10.96C2.7,11.13 2.32,11.14 2,10.96M12,4.15V4.15L12,10.85V10.85L17.96,7.5L12,4.15M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V12.69L14,15.59C13.67,15.77 13.3,15.76 13,15.6V19.29L19,15.91M13.85,13.36L20.13,9.73L19.55,8.72L13.27,12.35L13.85,13.36Z')
						| Tolerancia térmica: 
						span {{seleccionada_t['tolerancia-termica']}}
		template(slot='footer')
			router-link.btn.btn-primary(to="/contacto#contacto") Solicitar ficha técnica
			base-button.ml-auto(type='link', @click='modalT=false')
				| Cerrar

</template>

<script>
	//import { cajas } from '@/data/cajas'
	//import { tapas } from '@/data/tapas'
	import Modal from "@/components/Modal.vue";

	export default {
		components:{
			Modal
		},
		data(){
			return{
				cajas:[],
				tapas:[],
				seleccionada_c:{},
				seleccionada_t:{},
				modalC:false,
				modalT:false
			}
		},
		methods: {
			vamonos(){
				this.modalT = false
				//document.body.classList.remove('modal-open')
				//if(!document.body.className.match('modal-open'))
				 	this.$router.push('contacto')
				//-if(!this.modalT)  t
					
			},
			show_mocalC: function(caja) {
				this.seleccionada_c = caja
				this.modalC = true
			},
			show_modalT: function(tapa) {
				this.seleccionada_t = tapa
				this.modalT = true
			},
			webp(i){ if(!!i) return `${i.split('.')[1]}.webp` }
		},
		created(){
			fetch('/data/cajas.json')
			.then( response => response.json() )
			.then(data => {
				this.cajas = data
				console.log(data)
			} )
			.catch( err => console.error(err ) )

			fetch('/data/tapas.json')
			.then( response => response.json() )
			.then(data => {
				this.tapas = data
				console.log(data)
			} )
			.catch( err => console.error(err ) )
		}
	}
</script>

<style lang="scss" scoped >
	.heroPlastomex{
		background-image: url('/img/optimizadas/DSC03114.jpg');
	}
	.webp .heroPlastomex{
		background-image: url('/img/optimizadas/DSC03114.webp');
	}
	.modal-title{
		font-size: 2em;
		color: #74aa50;
	}
</style>